import { Component, OnInit, Output, EventEmitter, Input, Renderer2, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-afq',
  templateUrl: './afq.component.html',
  styleUrls: ['./afq.component.css']
})
export class AfqComponent {
  @Output() onClick = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Input() id: string;
  @Input() isSubmitted: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() isResultPublished: boolean = false;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() element
  _answer: any;
  @Input() set answer(val: any) {
    if (val) {
      this.questionChecked=true;
      this._answer = val;
      this.answersString = this._answer;
    }
  }
  @Input() points: any;
 
  @Input() variableFeedback: any;

  
  @Input() stopCameraTag;
  @Input() taFeedback: any;
  @Input() index: any;
  @Input() exerciseTimetrackingdata;
  @Input() fixedEditor: any;
  disableNavButton: boolean = false;
  @Output() back = new EventEmitter<Boolean>(false);
  answersString: string = '';
  questionChecked: boolean = false;
  @Input() questionUrl:any;
  @Input() playerindex:any;
  @Input() questionBlos;

  constructor(private renderer: Renderer2) {

  }


  urlHandller(event) {
    this.answersString = event;
  }

  next() {
    this.onClick.emit({ elementId: this.id, answer: this.answersString })
  }

  backHandler() {
    this.back.emit(true);
  }

  recordingHandler(event) {
    this.disableNavButton = event;
  }
  check() {
    this.questionChecked = true;
    this.onReview.emit({ elementId: this.id, answer: this.answersString })
  }
  skip() {
    this.onClick.emit({ elementId: this.id, answer: '' });
  }
  get questionAttempted() {
    return this.answersString.length > 0
  }

}
